import React from 'react';
import { Icon, type IconProps } from '../icon/icon';

export type TagIconProps = Omit<IconProps, 'mode'>;

export const TagIcon = React.forwardRef<
  React.ElementRef<typeof Icon>,
  TagIconProps
>((props, ref) => {
  return <Icon mode={100} {...props} ref={ref} />;
});

TagIcon.displayName = 'Tag.Icon';
